<template>
    <div>
        <modal class="auto-send" :display="modalStatus.autoSend" @modalStatus="closeModal" >
            <h1>收租提醒</h1>
            <div class="auto-send-wrap">
                <div class="description">
                    在每月應繳日前五天時，將自動發推播提醒您設定本月租金
                </div>
                <div class="setting">
                    <div class="title">
                        收租提醒：{{isOpen}}
                    </div>
                    <div class="switch">
                        <rent-switch v-model="value" :dValue="isAutoSend" ></rent-switch>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="setAutoSend">儲存設定</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import { mapGetters } from 'vuex'

import { 
    apiSetAutoSendBill
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            value: false
        }
    },
    props: {
        cid: Number,
        isAutoSend: Boolean
    },
    // mounted() {
    //     if(this.modalStatus.autoSend){
    //         console.log('收租提醒')
    //         this.$analytics.logEvent('收租提醒', { screen_name: '收租提醒'})
    //     }
    // },
    watch: {
        isAutoSend: {
            handler: function (value) {
                this.value = value
            },
            immediate: true
        },
    },
    methods: {
        setAutoSend: function () {
            this.$analytics.logEvent('送出收租提醒', { screen_name: '送出收租提醒'})

            let data = [{
                "contractCid" : this.cid,
                "autoSend" : this.value,
            }]
            apiSetAutoSendBill(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$emit('saveAutoStatus');
                    this.closeModal()
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'autoSend'})
        },
    },
    computed: {
        isOpen: function () {
            if(this.value){
                return '開啟'
            }else{
                return '關閉'
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSwitch
    }
}
</script>
<style lang="scss"  >
    #modal.auto-send{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .auto-send-wrap{
                    padding: 0 32px 0 32px;
                    .description{
                        font-weight: 300;
                        line-height: 1.57;
                        margin-bottom: 20px;
                    }
                    .setting{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-top: 1px solid #f3f3f3;
                        border-bottom: 1px solid #f3f3f3;
                        padding: 23px 0;
                        margin-bottom: 120px;
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/autoSend.vue